import { render } from "./FAQDialog.vue?vue&type=template&id=8ee4fbd2&scoped=true&lang=pug"
import script from "./FAQDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQDialog.vue?vue&type=script&setup=true&lang=js"

import "./FAQDialog.vue?vue&type=style&index=0&id=8ee4fbd2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee4fbd2"]])

export default __exports__